import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import i18nInit from "./i18n";
import { Logic } from "./logic";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const logic = new Logic();
// const i18n = i18nInit("en");

(window as any).app = {
  version: "0.0.1",
  // i18n,
  logic,
};

root.render(
  //   <React.StrictMode>
  <App logic={logic} />
  //   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
